<template>
  <div class="request-detail-response-files" data-testid="request-detail-response-files">
    <div
      v-for="(file, index) in files"
      :key="resolveAttachmentKey(file, index)"
      class="request-detail-response-files__item"
      :data-testid="`request-detail-response-files__item--${index}`"
    >
      <div class="request-detail-response-files__icon" aria-hidden="true">
        {{ fileExtension(file) }}
      </div>
      <div class="request-detail-response-files__meta">
        <p
          class="request-detail-response-files__name"
          data-testid="request-detail-response-files__name"
        >
          {{ fileName(file) }}
        </p>
        <p v-if="fileSize(file)" class="request-detail-response-files__size">
          {{ fileSize(file) }}
        </p>
      </div>
      <button
        type="button"
        class="request-detail-response-files__download"
        :aria-label="`Download ${fileName(file)}`"
        :data-testid="`request-detail-response-files__download--${index}`"
        @click="$emit('download', file)"
      >
        <img
          src="/img/icons/fbc-icons/DownloadIcon.svg"
          alt=""
          width="16"
          height="16"
        >
      </button>
    </div>
  </div>
</template>

<script>
import './RequestDetailResponseFiles.scss';
import { resolveAttachmentKey } from '../../utils/requestDetail';

export default {
  name: 'RequestDetailResponseFiles',
  props: {
    files: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    resolveAttachmentKey,
    fileName(file) {
      return file?.uploadname || file?.originalname || file?.file_name || 'Document';
    },
    fileExtension(file) {
      const name = this.fileName(file);
      if (!name || !name.includes('.')) return 'FILE';
      const ext = name.split('.').pop().toLowerCase();
      return (ext || 'FILE').toUpperCase().slice(0, 4);
    },
    fileSize(file) {
      const size = file?.size || file?.filesize;
      if (!size) return '';
      const numeric = Number(size);
      if (!Number.isFinite(numeric) || numeric <= 0) return '';
      if (numeric < 1024) return `${numeric} B`;
      if (numeric < 1024 * 1024) return `${(numeric / 1024).toFixed(1)} KB`;
      return `${(numeric / (1024 * 1024)).toFixed(1)} MB`;
    },
  },
};
</script>
